<td-layout>
  <td-navigation-drawer flex sidenavTitle="Ohio State Council" icon="home" [name]="userName" [email]="userEmail">
    <mat-nav-list>
      <a mat-list-item routerLink='council-summary' tdLayoutToggle><mat-icon>bar_chart</mat-icon>&nbsp;Council Summary</a>
      <a *ngIf="isSignedIn$ | async" mat-list-item routerLink='state-summary' tdLayoutToggle><mat-icon>list</mat-icon>&nbsp;State Summary</a>
      <a *ngIf="isSignedIn$ | async" mat-list-item routerLink='activities' tdLayoutToggle><mat-icon>inbox</mat-icon>&nbsp;Grade Activities</a>
      <a *ngIf="isSignedIn$ | async" mat-list-item routerLink='generate-reports' tdLayoutToggle><mat-icon>insights</mat-icon>&nbsp;Generate Reports</a>
    </mat-nav-list>
    <mat-nav-list>
        <a *ngIf="!(isSignedIn$ | async)" mat-list-item routerLink='login' tdLayoutToggle><mat-icon>account_circle</mat-icon>&nbsp;State Director Login</a>
        <a *ngIf="isSignedIn$ | async" mat-list-item (click)="signOut()" tdLayoutToggle><mat-icon>exit_to_app</mat-icon>&nbsp;Logout</a>
    </mat-nav-list>
  </td-navigation-drawer>
  <td-layout-nav color="none" toolbarTitle="Ohio State Council" class="content">
    <button mat-icon-button td-menu-button tdLayoutToggle>
      <mat-icon>menu</mat-icon>
    </button>
    <section class="inner-content">
      <app-header-logo></app-header-logo>
      <router-outlet></router-outlet>
      <br/>
    </section>
  </td-layout-nav>
</td-layout>
